import { render, staticRenderFns } from "./RegionStep.vue?vue&type=template&id=e2c78f6a&scoped=true&"
import script from "./RegionStep.vue?vue&type=script&lang=js&"
export * from "./RegionStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c78f6a",
  null
  
)

export default component.exports